// Éclairage d'une forme (objet nommé par la voix, `object.highlight`) :
// paliers du halo SVG et zone de calcul des filtres. Pur (testable sans DOM).

import { objectBox, type JrafObject, type ResolvedObject } from '@jeraisonne/animation';

/** Intensités des filtres d'éclairage SVG (le halo monte et descend par paliers). */
export const GLOW_LEVELS = [0.35, 0.6, 0.85, 1] as const;
/** Épaississement du trait d'une forme éclairée (× (1 + k × palier)). */
export const GLOW_STROKE_GAIN = 0.6;
/** Débord du halo autour d'une forme (dilatation + flou + trait épaissi). */
export const GLOW_MARGIN = 32;

/** Palier d'éclairage (0 = éteint, 1 … 4) : filtre SVG et épaisseur montent ensemble. */
export function glowLevel(glow: number): number {
  return glow <= 0.02 ? 0 : Math.min(GLOW_LEVELS.length, Math.ceil(glow * GLOW_LEVELS.length));
}

/**
 * Zone de calcul des filtres d'éclairage, dans le repère PROPRE des formes
 * (avant déplacement ; coordonnées relatives au groupe pour ses enfants) :
 * le canevas et toute forme qui en déborde, plus la marge du halo. Pas plus :
 * WebKit alloue les tampons du filtre à cette taille, à chaque image.
 */
export function glowRegion(
  objects: readonly ResolvedObject[],
  width: number,
  height: number,
): { x: number; y: number; width: number; height: number } {
  let minX = 0;
  let minY = 0;
  let maxX = width;
  let maxY = height;
  for (const o of objects) {
    let b: ReturnType<typeof objectBox> = null;
    try {
      b = objectBox(o as unknown as JrafObject, {});
    } catch {
      b = null;
    }
    if (!b || ![b.minX, b.minY, b.maxX, b.maxY].every(Number.isFinite)) continue;
    minX = Math.min(minX, b.minX);
    minY = Math.min(minY, b.minY);
    maxX = Math.max(maxX, b.maxX);
    maxY = Math.max(maxY, b.maxY);
  }
  return {
    x: minX - GLOW_MARGIN,
    y: minY - GLOW_MARGIN,
    width: maxX - minX + 2 * GLOW_MARGIN,
    height: maxY - minY + 2 * GLOW_MARGIN,
  };
}
